export const translateStatus = (status: string) => {
  const translations: Record<string, string> = {
    open: 'Abierto',
    closed: 'Cerrado',
    in_review: 'Revisión',
    paid: 'Pagado',
    pending: 'Pendiente',
    approved: 'Aprobado', 
    rejected: 'Rechazado',
    completed: 'Completado',
    cancelled: 'Cancelado'
  };
  
  return translations[status] || status;
};

export const translateRole = (role: string) => {
  switch (role) {
    case 'super_admin':
      return 'Administrador';
    case 'operator':
      return 'Operador';
    case 'branch_admin':
      return 'Admin. Sucursal';
    default:
      return 'No asignado';
  }
}